import React from "react";
const ChevronUp = () => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 8.925L18 14.925L16.925 16L12 11.05L7.075 15.975L6 14.9L12 8.925Z" fill="black" />
    </svg>
)

export default ChevronUp;